export * from './firebase.app.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angularfire2/app/index.js
// module id = ./node_modules/angularfire2/app/index.js
// module chunks = 2